export default "__VITE_ASSET__Ci7Qm5Ot__"